import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import "../../styles/avatar.scss";
import { AvatarProps } from "./type";

const Avatar = ({ name, url, style, value, tooltip }: AvatarProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const toggle = () => setShowTooltip(!showTooltip);
  const getName = () => {
    const arrName = name.split(" ");
    if (arrName.length >= 2)
      return `${arrName[0].charAt(0)}${arrName[1].charAt(0)}`.toUpperCase();
    return arrName[0].charAt(0).toUpperCase();
  };
  return (
    <div className="avatar-container" style={style} id={`avatar-${value}`}>
      {(url && <img className="avatar-source" src={url} alt="avatar" />) || (
        <span>{getName()}</span>
      )}
      {tooltip && (
        <Tooltip
          isOpen={showTooltip}
          toggle={toggle}
          placement="auto"
          target={`avatar-${value}`}
        >
          {name}
        </Tooltip>
      )}
    </div>
  );
};

export default Avatar;
